import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { ReactComponent as TickIcon } from 'Assets/svg/bg-tick.svg';
import { ReactComponent as ErrorIcon } from 'Assets/svg/bg-error.svg';
import { ReactComponent as WarningIcon } from 'Assets/svg/bg-warning.svg';
import * as CONSTANTS from 'Utils/constants';
import Utils from 'Utils/utils';

const { TOAST_MSG_TYPES } = CONSTANTS;

const defaultValue = {
  show: false,
  message: '',
  type: '',
  className: '',
};
class ToasterState {
  @observable toastOptions = defaultValue;

  @action
  setToastMsg = (customTxt, msgType, options = {}) => {
    const { callback, timeout = 3500, className = '' } = options;
    let str = '';
    const thisObj = this;

    if (customTxt !== null && customTxt !== undefined) {
      if (str !== '') str += ' <br />';
      str += customTxt;
    }

    if (window.timeoutVar !== undefined) clearTimeout(window.timeoutVar);
    setTimeout(function() {
      thisObj.toastOptions = {
        show: true,
        message: str,
        type: msgType?.toUpperCase() || TOAST_MSG_TYPES.FAILURE,
        className,
      };
      window.timeoutVar = setTimeout(function() {
        thisObj.toastOptions = defaultValue;
        if (Utils.isNotUndefinedNotNull(callback)) callback();
      }, timeout);
    }, 100);
  };
}

const toasterState = new ToasterState();

const Toaster = observer(() => {
  const className = `toast-wrapper${
    toasterState.toastOptions.show ? ' show-toast' : ''
  }${
    toasterState.toastOptions.className !== ''
      ? ` ${toasterState.toastOptions.className}`
      : ''
  } ${toasterState.toastOptions.type}`;
  return (
    <>
      <div className={className}>
        <div className="messageCont">
          {toasterState.toastOptions.type === TOAST_MSG_TYPES.WARNING ? (
            <span className="svgIcon tickIcon">
              <WarningIcon />
            </span>
          ) : toasterState.toastOptions.type === TOAST_MSG_TYPES.INFO ? (
            <span className="svgIcon infoIcon">
              <i className="material-icons">info</i>
            </span>
          ) : toasterState.toastOptions.type === TOAST_MSG_TYPES.SUCCESS ||
            toasterState.toastOptions.type === TOAST_MSG_TYPES.SUCCESS_NEW ? (
            <span className="svgIcon tickIcon">
              <TickIcon />
            </span>
          ) : (
            <span className="crossIcon svgIcon">
              <ErrorIcon />
            </span>
          )}
          <span
            className="message" // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: toasterState.toastOptions.message || '',
            }}
          />
        </div>
      </div>
    </>
  );
});
export { Toaster, toasterState };
export default Toaster;
